const companyNames = {
  Schadegarant: 'schadegarant',
  Rhion: 'Rhion',
  VIP: 'VIP'
}

export default companyNames;
